const sizes = {
  header: {
    mobile: "75px",
    desktop: "88px"
  }
};

export default sizes;
